import I151_duotone from "./phosphor/archive-duotone.svg?component-solid";
import I151_fill from "./phosphor/archive-fill.svg?component-solid";
import I151_regular from "./phosphor/archive-regular.svg?component-solid";
import I33_duotone from "./phosphor/arrow-bend-up-left-duotone.svg?component-solid";
import I33_fill from "./phosphor/arrow-bend-up-left-fill.svg?component-solid";
import I33_regular from "./phosphor/arrow-bend-up-left-regular.svg?component-solid";
import I170_duotone from "./phosphor/arrow-bend-up-right-duotone.svg?component-solid";
import I170_fill from "./phosphor/arrow-bend-up-right-fill.svg?component-solid";
import I170_regular from "./phosphor/arrow-bend-up-right-regular.svg?component-solid";
import I99_duotone from "./phosphor/arrow-clockwise-duotone.svg?component-solid";
import I99_fill from "./phosphor/arrow-clockwise-fill.svg?component-solid";
import I99_regular from "./phosphor/arrow-clockwise-regular.svg?component-solid";
import I123_duotone from "./phosphor/arrow-counter-clockwise-duotone.svg?component-solid";
import I123_fill from "./phosphor/arrow-counter-clockwise-fill.svg?component-solid";
import I123_regular from "./phosphor/arrow-counter-clockwise-regular.svg?component-solid";
import I49_duotone from "./phosphor/arrow-left-duotone.svg?component-solid";
import I49_fill from "./phosphor/arrow-left-fill.svg?component-solid";
import I49_regular from "./phosphor/arrow-left-regular.svg?component-solid";
import I50_duotone from "./phosphor/arrow-right-duotone.svg?component-solid";
import I50_fill from "./phosphor/arrow-right-fill.svg?component-solid";
import I50_regular from "./phosphor/arrow-right-regular.svg?component-solid";
import I62_duotone from "./phosphor/arrow-square-out-duotone.svg?component-solid";
import I62_fill from "./phosphor/arrow-square-out-fill.svg?component-solid";
import I62_regular from "./phosphor/arrow-square-out-regular.svg?component-solid";
import I171_duotone from "./phosphor/arrow-u-up-left-duotone.svg?component-solid";
import I171_fill from "./phosphor/arrow-u-up-left-fill.svg?component-solid";
import I171_regular from "./phosphor/arrow-u-up-left-regular.svg?component-solid";
import I172_duotone from "./phosphor/arrow-u-up-right-duotone.svg?component-solid";
import I172_fill from "./phosphor/arrow-u-up-right-fill.svg?component-solid";
import I172_regular from "./phosphor/arrow-u-up-right-regular.svg?component-solid";
import I51_duotone from "./phosphor/arrow-up-left-duotone.svg?component-solid";
import I51_fill from "./phosphor/arrow-up-left-fill.svg?component-solid";
import I51_regular from "./phosphor/arrow-up-left-regular.svg?component-solid";
import I100_duotone from "./phosphor/arrows-clockwise-duotone.svg?component-solid";
import I100_fill from "./phosphor/arrows-clockwise-fill.svg?component-solid";
import I100_regular from "./phosphor/arrows-clockwise-regular.svg?component-solid";
import I166_duotone from "./phosphor/arrows-down-up-duotone.svg?component-solid";
import I166_fill from "./phosphor/arrows-down-up-fill.svg?component-solid";
import I166_regular from "./phosphor/arrows-down-up-regular.svg?component-solid";
import I61_duotone from "./phosphor/arrows-in-duotone.svg?component-solid";
import I61_fill from "./phosphor/arrows-in-fill.svg?component-solid";
import I59_duotone from "./phosphor/arrows-in-line-vertical-duotone.svg?component-solid";
import I59_fill from "./phosphor/arrows-in-line-vertical-fill.svg?component-solid";
import I59_regular from "./phosphor/arrows-in-line-vertical-regular.svg?component-solid";
import I61_regular from "./phosphor/arrows-in-regular.svg?component-solid";
import I60_duotone from "./phosphor/arrows-out-duotone.svg?component-solid";
import I60_fill from "./phosphor/arrows-out-fill.svg?component-solid";
import I58_duotone from "./phosphor/arrows-out-line-vertical-duotone.svg?component-solid";
import I58_fill from "./phosphor/arrows-out-line-vertical-fill.svg?component-solid";
import I58_regular from "./phosphor/arrows-out-line-vertical-regular.svg?component-solid";
import I60_regular from "./phosphor/arrows-out-regular.svg?component-solid";
import I88_duotone from "./phosphor/at-duotone.svg?component-solid";
import I88_fill from "./phosphor/at-fill.svg?component-solid";
import I88_regular from "./phosphor/at-regular.svg?component-solid";
import I5_duotone from "./phosphor/bell-duotone.svg?component-solid";
import I5_fill from "./phosphor/bell-fill.svg?component-solid";
import I5_regular from "./phosphor/bell-regular.svg?component-solid";
import I187_duotone from "./phosphor/bell-ringing-duotone.svg?component-solid";
import I187_fill from "./phosphor/bell-ringing-fill.svg?component-solid";
import I187_regular from "./phosphor/bell-ringing-regular.svg?component-solid";
import I6_duotone from "./phosphor/bell-slash-duotone.svg?component-solid";
import I6_fill from "./phosphor/bell-slash-fill.svg?component-solid";
import I6_regular from "./phosphor/bell-slash-regular.svg?component-solid";
import I113_duotone from "./phosphor/bookmark-simple-duotone.svg?component-solid";
import I113_fill from "./phosphor/bookmark-simple-fill.svg?component-solid";
import I113_regular from "./phosphor/bookmark-simple-regular.svg?component-solid";
import I174_duotone from "./phosphor/books-duotone.svg?component-solid";
import I174_fill from "./phosphor/books-fill.svg?component-solid";
import I174_regular from "./phosphor/books-regular.svg?component-solid";
import I133_duotone from "./phosphor/bug-duotone.svg?component-solid";
import I133_fill from "./phosphor/bug-fill.svg?component-solid";
import I133_regular from "./phosphor/bug-regular.svg?component-solid";
import I173_duotone from "./phosphor/cake-duotone.svg?component-solid";
import I173_fill from "./phosphor/cake-fill.svg?component-solid";
import I173_regular from "./phosphor/cake-regular.svg?component-solid";
import I177_duotone from "./phosphor/calendar-duotone.svg?component-solid";
import I177_fill from "./phosphor/calendar-fill.svg?component-solid";
import I177_regular from "./phosphor/calendar-regular.svg?component-solid";
import I188_duotone from "./phosphor/caret-double-left-duotone.svg?component-solid";
import I188_fill from "./phosphor/caret-double-left-fill.svg?component-solid";
import I188_regular from "./phosphor/caret-double-left-regular.svg?component-solid";
import I189_duotone from "./phosphor/caret-double-right-duotone.svg?component-solid";
import I189_fill from "./phosphor/caret-double-right-fill.svg?component-solid";
import I189_regular from "./phosphor/caret-double-right-regular.svg?component-solid";
import I52_duotone from "./phosphor/caret-down-duotone.svg?component-solid";
import I52_fill from "./phosphor/caret-down-fill.svg?component-solid";
import I52_regular from "./phosphor/caret-down-regular.svg?component-solid";
import I55_duotone from "./phosphor/caret-left-duotone.svg?component-solid";
import I55_fill from "./phosphor/caret-left-fill.svg?component-solid";
import I55_regular from "./phosphor/caret-left-regular.svg?component-solid";
import I54_duotone from "./phosphor/caret-right-duotone.svg?component-solid";
import I54_fill from "./phosphor/caret-right-fill.svg?component-solid";
import I54_regular from "./phosphor/caret-right-regular.svg?component-solid";
import I53_duotone from "./phosphor/caret-up-duotone.svg?component-solid";
import I53_fill from "./phosphor/caret-up-fill.svg?component-solid";
import I53_regular from "./phosphor/caret-up-regular.svg?component-solid";
import I145_duotone from "./phosphor/cell-signal-full-duotone.svg?component-solid";
import I145_fill from "./phosphor/cell-signal-full-fill.svg?component-solid";
import I145_regular from "./phosphor/cell-signal-full-regular.svg?component-solid";
import I182_duotone from "./phosphor/chat-centered-text-duotone.svg?component-solid";
import I182_fill from "./phosphor/chat-centered-text-fill.svg?component-solid";
import I182_regular from "./phosphor/chat-centered-text-regular.svg?component-solid";
import I178_duotone from "./phosphor/chat-circle-dots-duotone.svg?component-solid";
import I178_fill from "./phosphor/chat-circle-dots-fill.svg?component-solid";
import I178_regular from "./phosphor/chat-circle-dots-regular.svg?component-solid";
import I36_duotone from "./phosphor/chat-circle-duotone.svg?component-solid";
import I36_fill from "./phosphor/chat-circle-fill.svg?component-solid";
import I36_regular from "./phosphor/chat-circle-regular.svg?component-solid";
import I37_duotone from "./phosphor/chats-circle-duotone.svg?component-solid";
import I37_fill from "./phosphor/chats-circle-fill.svg?component-solid";
import I37_regular from "./phosphor/chats-circle-regular.svg?component-solid";
import I46_duotone from "./phosphor/check-circle-duotone.svg?component-solid";
import I46_fill from "./phosphor/check-circle-fill.svg?component-solid";
import I46_regular from "./phosphor/check-circle-regular.svg?component-solid";
import I45_duotone from "./phosphor/check-duotone.svg?component-solid";
import I45_fill from "./phosphor/check-fill.svg?component-solid";
import I45_regular from "./phosphor/check-regular.svg?component-solid";
import I47_duotone from "./phosphor/check-square-duotone.svg?component-solid";
import I47_fill from "./phosphor/check-square-fill.svg?component-solid";
import I47_regular from "./phosphor/check-square-regular.svg?component-solid";
import I139_duotone from "./phosphor/circle-duotone.svg?component-solid";
import I139_fill from "./phosphor/circle-fill.svg?component-solid";
import I164_duotone from "./phosphor/circle-half-duotone.svg?component-solid";
import I164_fill from "./phosphor/circle-half-fill.svg?component-solid";
import I164_regular from "./phosphor/circle-half-regular.svg?component-solid";
import I139_regular from "./phosphor/circle-regular.svg?component-solid";
import I119_duotone from "./phosphor/clock-counter-clockwise-duotone.svg?component-solid";
import I119_fill from "./phosphor/clock-counter-clockwise-fill.svg?component-solid";
import I119_regular from "./phosphor/clock-counter-clockwise-regular.svg?component-solid";
import I84_duotone from "./phosphor/clock-duotone.svg?component-solid";
import I84_fill from "./phosphor/clock-fill.svg?component-solid";
import I84_regular from "./phosphor/clock-regular.svg?component-solid";
import I118_duotone from "./phosphor/cloud-arrow-down-duotone.svg?component-solid";
import I118_fill from "./phosphor/cloud-arrow-down-fill.svg?component-solid";
import I118_regular from "./phosphor/cloud-arrow-down-regular.svg?component-solid";
import I132_duotone from "./phosphor/code-duotone.svg?component-solid";
import I132_fill from "./phosphor/code-fill.svg?component-solid";
import I132_regular from "./phosphor/code-regular.svg?component-solid";
import I176_duotone from "./phosphor/coin-duotone.svg?component-solid";
import I176_fill from "./phosphor/coin-fill.svg?component-solid";
import I176_regular from "./phosphor/coin-regular.svg?component-solid";
import I66_duotone from "./phosphor/compass-duotone.svg?component-solid";
import I66_fill from "./phosphor/compass-fill.svg?component-solid";
import I66_regular from "./phosphor/compass-regular.svg?component-solid";
import I154_duotone from "./phosphor/confetti-duotone.svg?component-solid";
import I154_fill from "./phosphor/confetti-fill.svg?component-solid";
import I154_regular from "./phosphor/confetti-regular.svg?component-solid";
import I16_duotone from "./phosphor/copy-duotone.svg?component-solid";
import I16_fill from "./phosphor/copy-fill.svg?component-solid";
import I16_regular from "./phosphor/copy-regular.svg?component-solid";
import I181_duotone from "./phosphor/cpu-duotone.svg?component-solid";
import I181_fill from "./phosphor/cpu-fill.svg?component-solid";
import I181_regular from "./phosphor/cpu-regular.svg?component-solid";
import I134_duotone from "./phosphor/currency-circle-dollar-duotone.svg?component-solid";
import I134_fill from "./phosphor/currency-circle-dollar-fill.svg?component-solid";
import I134_regular from "./phosphor/currency-circle-dollar-regular.svg?component-solid";
import I90_duotone from "./phosphor/desktop-duotone.svg?component-solid";
import I90_fill from "./phosphor/desktop-fill.svg?component-solid";
import I90_regular from "./phosphor/desktop-regular.svg?component-solid";
import I142_duotone from "./phosphor/device-mobile-duotone.svg?component-solid";
import I142_fill from "./phosphor/device-mobile-fill.svg?component-solid";
import I142_regular from "./phosphor/device-mobile-regular.svg?component-solid";
import I168_duotone from "./phosphor/dots-six-duotone.svg?component-solid";
import I168_fill from "./phosphor/dots-six-fill.svg?component-solid";
import I168_regular from "./phosphor/dots-six-regular.svg?component-solid";
import I167_duotone from "./phosphor/dots-six-vertical-duotone.svg?component-solid";
import I167_fill from "./phosphor/dots-six-vertical-fill.svg?component-solid";
import I167_regular from "./phosphor/dots-six-vertical-regular.svg?component-solid";
import I56_duotone from "./phosphor/dots-three-duotone.svg?component-solid";
import I56_fill from "./phosphor/dots-three-fill.svg?component-solid";
import I56_regular from "./phosphor/dots-three-regular.svg?component-solid";
import I57_duotone from "./phosphor/dots-three-vertical-duotone.svg?component-solid";
import I57_fill from "./phosphor/dots-three-vertical-fill.svg?component-solid";
import I57_regular from "./phosphor/dots-three-vertical-regular.svg?component-solid";
import I30_duotone from "./phosphor/download-simple-duotone.svg?component-solid";
import I30_fill from "./phosphor/download-simple-fill.svg?component-solid";
import I30_regular from "./phosphor/download-simple-regular.svg?component-solid";
import I89_duotone from "./phosphor/envelope-duotone.svg?component-solid";
import I89_fill from "./phosphor/envelope-fill.svg?component-solid";
import I89_regular from "./phosphor/envelope-regular.svg?component-solid";
import I81_duotone from "./phosphor/eye-duotone.svg?component-solid";
import I81_fill from "./phosphor/eye-fill.svg?component-solid";
import I81_regular from "./phosphor/eye-regular.svg?component-solid";
import I82_duotone from "./phosphor/eye-slash-duotone.svg?component-solid";
import I82_fill from "./phosphor/eye-slash-fill.svg?component-solid";
import I82_regular from "./phosphor/eye-slash-regular.svg?component-solid";
import I141_duotone from "./phosphor/file-duotone.svg?component-solid";
import I141_fill from "./phosphor/file-fill.svg?component-solid";
import I141_regular from "./phosphor/file-regular.svg?component-solid";
import I64_duotone from "./phosphor/file-text-duotone.svg?component-solid";
import I64_fill from "./phosphor/file-text-fill.svg?component-solid";
import I64_regular from "./phosphor/file-text-regular.svg?component-solid";
import I79_duotone from "./phosphor/flag-duotone.svg?component-solid";
import I79_fill from "./phosphor/flag-fill.svg?component-solid";
import I79_regular from "./phosphor/flag-regular.svg?component-solid";
import I135_duotone from "./phosphor/flask-duotone.svg?component-solid";
import I135_fill from "./phosphor/flask-fill.svg?component-solid";
import I135_regular from "./phosphor/flask-regular.svg?component-solid";
import I117_duotone from "./phosphor/floppy-disk-duotone.svg?component-solid";
import I117_fill from "./phosphor/floppy-disk-fill.svg?component-solid";
import I117_regular from "./phosphor/floppy-disk-regular.svg?component-solid";
import I109_duotone from "./phosphor/folder-duotone.svg?component-solid";
import I109_fill from "./phosphor/folder-fill.svg?component-solid";
import I186_duotone from "./phosphor/folder-minus-duotone.svg?component-solid";
import I186_fill from "./phosphor/folder-minus-fill.svg?component-solid";
import I186_regular from "./phosphor/folder-minus-regular.svg?component-solid";
import I110_duotone from "./phosphor/folder-open-duotone.svg?component-solid";
import I110_fill from "./phosphor/folder-open-fill.svg?component-solid";
import I110_regular from "./phosphor/folder-open-regular.svg?component-solid";
import I185_duotone from "./phosphor/folder-plus-duotone.svg?component-solid";
import I185_fill from "./phosphor/folder-plus-fill.svg?component-solid";
import I185_regular from "./phosphor/folder-plus-regular.svg?component-solid";
import I109_regular from "./phosphor/folder-regular.svg?component-solid";
import I116_duotone from "./phosphor/funnel-duotone.svg?component-solid";
import I116_fill from "./phosphor/funnel-fill.svg?component-solid";
import I116_regular from "./phosphor/funnel-regular.svg?component-solid";
import I155_duotone from "./phosphor/game-controller-duotone.svg?component-solid";
import I155_fill from "./phosphor/game-controller-fill.svg?component-solid";
import I155_regular from "./phosphor/game-controller-regular.svg?component-solid";
import I80_duotone from "./phosphor/gavel-duotone.svg?component-solid";
import I80_fill from "./phosphor/gavel-fill.svg?component-solid";
import I80_regular from "./phosphor/gavel-regular.svg?component-solid";
import I3_duotone from "./phosphor/gear-six-duotone.svg?component-solid";
import I3_fill from "./phosphor/gear-six-fill.svg?component-solid";
import I3_regular from "./phosphor/gear-six-regular.svg?component-solid";
import I94_regular from "./phosphor/gif-regular.svg?component-solid";
import I153_duotone from "./phosphor/gift-duotone.svg?component-solid";
import I153_fill from "./phosphor/gift-fill.svg?component-solid";
import I153_regular from "./phosphor/gift-regular.svg?component-solid";
import I67_duotone from "./phosphor/globe-duotone.svg?component-solid";
import I67_fill from "./phosphor/globe-fill.svg?component-solid";
import I67_regular from "./phosphor/globe-regular.svg?component-solid";
import I92_duotone from "./phosphor/grid-nine-duotone.svg?component-solid";
import I92_fill from "./phosphor/grid-nine-fill.svg?component-solid";
import I92_regular from "./phosphor/grid-nine-regular.svg?component-solid";
import I104_duotone from "./phosphor/hand-waving-duotone.svg?component-solid";
import I104_fill from "./phosphor/hand-waving-fill.svg?component-solid";
import I104_regular from "./phosphor/hand-waving-regular.svg?component-solid";
import I35_fill from "./phosphor/hash-fill.svg?component-solid";
import I35_regular from "./phosphor/hash-regular.svg?component-solid";
import I19_duotone from "./phosphor/headphones-duotone.svg?component-solid";
import I19_fill from "./phosphor/headphones-fill.svg?component-solid";
import I19_regular from "./phosphor/headphones-regular.svg?component-solid";
import I21_duotone from "./phosphor/headset-duotone.svg?component-solid";
import I21_fill from "./phosphor/headset-fill.svg?component-solid";
import I21_regular from "./phosphor/headset-regular.svg?component-solid";
import I112_duotone from "./phosphor/heart-duotone.svg?component-solid";
import I112_fill from "./phosphor/heart-fill.svg?component-solid";
import I112_regular from "./phosphor/heart-regular.svg?component-solid";
import I85_duotone from "./phosphor/hourglass-duotone.svg?component-solid";
import I85_fill from "./phosphor/hourglass-fill.svg?component-solid";
import I85_regular from "./phosphor/hourglass-regular.svg?component-solid";
import I0_duotone from "./phosphor/house-duotone.svg?component-solid";
import I0_fill from "./phosphor/house-fill.svg?component-solid";
import I0_regular from "./phosphor/house-regular.svg?component-solid";
import I86_duotone from "./phosphor/identification-badge-duotone.svg?component-solid";
import I86_fill from "./phosphor/identification-badge-fill.svg?component-solid";
import I86_regular from "./phosphor/identification-badge-regular.svg?component-solid";
import I87_duotone from "./phosphor/identification-card-duotone.svg?component-solid";
import I87_fill from "./phosphor/identification-card-fill.svg?component-solid";
import I87_regular from "./phosphor/identification-card-regular.svg?component-solid";
import I95_duotone from "./phosphor/image-duotone.svg?component-solid";
import I95_fill from "./phosphor/image-fill.svg?component-solid";
import I95_regular from "./phosphor/image-regular.svg?component-solid";
import I75_duotone from "./phosphor/info-duotone.svg?component-solid";
import I75_fill from "./phosphor/info-fill.svg?component-solid";
import I75_regular from "./phosphor/info-regular.svg?component-solid";
import I73_duotone from "./phosphor/key-duotone.svg?component-solid";
import I73_fill from "./phosphor/key-fill.svg?component-solid";
import I73_regular from "./phosphor/key-regular.svg?component-solid";
import I91_duotone from "./phosphor/keyboard-duotone.svg?component-solid";
import I91_fill from "./phosphor/keyboard-fill.svg?component-solid";
import I91_regular from "./phosphor/keyboard-regular.svg?component-solid";
import I105_duotone from "./phosphor/leaf-duotone.svg?component-solid";
import I105_fill from "./phosphor/leaf-fill.svg?component-solid";
import I105_regular from "./phosphor/leaf-regular.svg?component-solid";
import I146_duotone from "./phosphor/lightning-duotone.svg?component-solid";
import I146_fill from "./phosphor/lightning-fill.svg?component-solid";
import I146_regular from "./phosphor/lightning-regular.svg?component-solid";
import I15_duotone from "./phosphor/link-duotone.svg?component-solid";
import I15_fill from "./phosphor/link-fill.svg?component-solid";
import I15_regular from "./phosphor/link-regular.svg?component-solid";
import I157_duotone from "./phosphor/list-bullets-duotone.svg?component-solid";
import I157_fill from "./phosphor/list-bullets-fill.svg?component-solid";
import I157_regular from "./phosphor/list-bullets-regular.svg?component-solid";
import I156_duotone from "./phosphor/list-checks-duotone.svg?component-solid";
import I156_fill from "./phosphor/list-checks-fill.svg?component-solid";
import I156_regular from "./phosphor/list-checks-regular.svg?component-solid";
import I93_duotone from "./phosphor/list-duotone.svg?component-solid";
import I93_fill from "./phosphor/list-fill.svg?component-solid";
import I158_duotone from "./phosphor/list-numbers-duotone.svg?component-solid";
import I158_fill from "./phosphor/list-numbers-fill.svg?component-solid";
import I158_regular from "./phosphor/list-numbers-regular.svg?component-solid";
import I93_regular from "./phosphor/list-regular.svg?component-solid";
import I71_duotone from "./phosphor/lock-simple-duotone.svg?component-solid";
import I71_fill from "./phosphor/lock-simple-fill.svg?component-solid";
import I72_duotone from "./phosphor/lock-simple-open-duotone.svg?component-solid";
import I72_fill from "./phosphor/lock-simple-open-fill.svg?component-solid";
import I72_regular from "./phosphor/lock-simple-open-regular.svg?component-solid";
import I71_regular from "./phosphor/lock-simple-regular.svg?component-solid";
import I4_duotone from "./phosphor/magnifying-glass-duotone.svg?component-solid";
import I4_fill from "./phosphor/magnifying-glass-fill.svg?component-solid";
import I103_duotone from "./phosphor/magnifying-glass-minus-duotone.svg?component-solid";
import I103_fill from "./phosphor/magnifying-glass-minus-fill.svg?component-solid";
import I103_regular from "./phosphor/magnifying-glass-minus-regular.svg?component-solid";
import I102_duotone from "./phosphor/magnifying-glass-plus-duotone.svg?component-solid";
import I102_fill from "./phosphor/magnifying-glass-plus-fill.svg?component-solid";
import I102_regular from "./phosphor/magnifying-glass-plus-regular.svg?component-solid";
import I4_regular from "./phosphor/magnifying-glass-regular.svg?component-solid";
import I183_duotone from "./phosphor/medal-duotone.svg?component-solid";
import I183_fill from "./phosphor/medal-fill.svg?component-solid";
import I183_regular from "./phosphor/medal-regular.svg?component-solid";
import I180_duotone from "./phosphor/megaphone-duotone.svg?component-solid";
import I180_fill from "./phosphor/megaphone-fill.svg?component-solid";
import I180_regular from "./phosphor/megaphone-regular.svg?component-solid";
import I17_duotone from "./phosphor/microphone-duotone.svg?component-solid";
import I17_fill from "./phosphor/microphone-fill.svg?component-solid";
import I17_regular from "./phosphor/microphone-regular.svg?component-solid";
import I18_duotone from "./phosphor/microphone-slash-duotone.svg?component-solid";
import I18_fill from "./phosphor/microphone-slash-fill.svg?component-solid";
import I18_regular from "./phosphor/microphone-slash-regular.svg?component-solid";
import I69_duotone from "./phosphor/minus-circle-duotone.svg?component-solid";
import I69_fill from "./phosphor/minus-circle-fill.svg?component-solid";
import I69_regular from "./phosphor/minus-circle-regular.svg?component-solid";
import I42_duotone from "./phosphor/minus-duotone.svg?component-solid";
import I42_fill from "./phosphor/minus-fill.svg?component-solid";
import I42_regular from "./phosphor/minus-regular.svg?component-solid";
import IMonUp_duotone from "./phosphor/monitor-arrow-up-duotone.svg?component-solid";
import IMonUp_fill from "./phosphor/monitor-arrow-up-fill.svg?component-solid";
import IMonUp_regular from "./phosphor/monitor-arrow-up-regular.svg?component-solid";
import I28_duotone from "./phosphor/monitor-duotone.svg?component-solid";
import I28_fill from "./phosphor/monitor-fill.svg?component-solid";
import I28_regular from "./phosphor/monitor-regular.svg?component-solid";
import I163_duotone from "./phosphor/moon-duotone.svg?component-solid";
import I163_fill from "./phosphor/moon-fill.svg?component-solid";
import I163_regular from "./phosphor/moon-regular.svg?component-solid";
import I140_duotone from "./phosphor/music-note-duotone.svg?component-solid";
import I140_fill from "./phosphor/music-note-fill.svg?component-solid";
import I140_regular from "./phosphor/music-note-regular.svg?component-solid";
import I12_duotone from "./phosphor/note-pencil-duotone.svg?component-solid";
import I12_fill from "./phosphor/note-pencil-fill.svg?component-solid";
import I12_regular from "./phosphor/note-pencil-regular.svg?component-solid";
import I63_duotone from "./phosphor/notebook-duotone.svg?component-solid";
import I63_fill from "./phosphor/notebook-fill.svg?component-solid";
import I63_regular from "./phosphor/notebook-regular.svg?component-solid";
import I179_duotone from "./phosphor/paint-brush-duotone.svg?component-solid";
import I179_fill from "./phosphor/paint-brush-fill.svg?component-solid";
import I179_regular from "./phosphor/paint-brush-regular.svg?component-solid";
import I96_duotone from "./phosphor/palette-duotone.svg?component-solid";
import I96_fill from "./phosphor/palette-fill.svg?component-solid";
import I96_regular from "./phosphor/palette-regular.svg?component-solid";
import I34_duotone from "./phosphor/paper-plane-tilt-duotone.svg?component-solid";
import I34_fill from "./phosphor/paper-plane-tilt-fill.svg?component-solid";
import I34_regular from "./phosphor/paper-plane-tilt-regular.svg?component-solid";
import I29_duotone from "./phosphor/paperclip-duotone.svg?component-solid";
import I29_fill from "./phosphor/paperclip-fill.svg?component-solid";
import I29_regular from "./phosphor/paperclip-regular.svg?component-solid";
import I74_duotone from "./phosphor/password-duotone.svg?component-solid";
import I74_fill from "./phosphor/password-fill.svg?component-solid";
import I74_regular from "./phosphor/password-regular.svg?component-solid";
import I121_duotone from "./phosphor/pause-duotone.svg?component-solid";
import I121_fill from "./phosphor/pause-fill.svg?component-solid";
import I121_regular from "./phosphor/pause-regular.svg?component-solid";
import I11_duotone from "./phosphor/pencil-simple-duotone.svg?component-solid";
import I11_fill from "./phosphor/pencil-simple-fill.svg?component-solid";
import I11_regular from "./phosphor/pencil-simple-regular.svg?component-solid";
import I162_duotone from "./phosphor/person-arms-spread-duotone.svg?component-solid";
import I162_fill from "./phosphor/person-arms-spread-fill.svg?component-solid";
import I162_regular from "./phosphor/person-arms-spread-regular.svg?component-solid";
import I24_duotone from "./phosphor/phone-disconnect-duotone.svg?component-solid";
import I24_fill from "./phosphor/phone-disconnect-fill.svg?component-solid";
import I24_regular from "./phosphor/phone-disconnect-regular.svg?component-solid";
import I23_duotone from "./phosphor/phone-duotone.svg?component-solid";
import I23_fill from "./phosphor/phone-fill.svg?component-solid";
import I23_regular from "./phosphor/phone-regular.svg?component-solid";
import I120_duotone from "./phosphor/play-duotone.svg?component-solid";
import I120_fill from "./phosphor/play-fill.svg?component-solid";
import I120_regular from "./phosphor/play-regular.svg?component-solid";
import I40_duotone from "./phosphor/plus-circle-duotone.svg?component-solid";
import I40_fill from "./phosphor/plus-circle-fill.svg?component-solid";
import I40_regular from "./phosphor/plus-circle-regular.svg?component-solid";
import I39_fill from "./phosphor/plus-fill.svg?component-solid";
import I39_regular from "./phosphor/plus-regular.svg?component-solid";
import I41_duotone from "./phosphor/plus-square-duotone.svg?component-solid";
import I41_fill from "./phosphor/plus-square-fill.svg?component-solid";
import I41_regular from "./phosphor/plus-square-regular.svg?component-solid";
import I68_duotone from "./phosphor/prohibit-duotone.svg?component-solid";
import I68_fill from "./phosphor/prohibit-fill.svg?component-solid";
import I68_regular from "./phosphor/prohibit-regular.svg?component-solid";
import I14_duotone from "./phosphor/push-pin-duotone.svg?component-solid";
import I14_fill from "./phosphor/push-pin-fill.svg?component-solid";
import I14_regular from "./phosphor/push-pin-regular.svg?component-solid";
import I101_duotone from "./phosphor/question-duotone.svg?component-solid";
import I101_fill from "./phosphor/question-fill.svg?component-solid";
import I101_regular from "./phosphor/question-regular.svg?component-solid";
import I131_duotone from "./phosphor/quotes-duotone.svg?component-solid";
import I131_fill from "./phosphor/quotes-fill.svg?component-solid";
import I131_regular from "./phosphor/quotes-regular.svg?component-solid";
import I138_duotone from "./phosphor/radio-button-duotone.svg?component-solid";
import I138_fill from "./phosphor/radio-button-fill.svg?component-solid";
import I138_regular from "./phosphor/radio-button-regular.svg?component-solid";
import I175_duotone from "./phosphor/robot-duotone.svg?component-solid";
import I175_fill from "./phosphor/robot-fill.svg?component-solid";
import I175_regular from "./phosphor/robot-regular.svg?component-solid";
import I148_duotone from "./phosphor/rocket-launch-duotone.svg?component-solid";
import I148_fill from "./phosphor/rocket-launch-fill.svg?component-solid";
import I148_regular from "./phosphor/rocket-launch-regular.svg?component-solid";
import I27_duotone from "./phosphor/screencast-duotone.svg?component-solid";
import I27_fill from "./phosphor/screencast-fill.svg?component-solid";
import I27_regular from "./phosphor/screencast-regular.svg?component-solid";
import I125_duotone from "./phosphor/seal-check-duotone.svg?component-solid";
import I125_fill from "./phosphor/seal-check-fill.svg?component-solid";
import I125_regular from "./phosphor/seal-check-regular.svg?component-solid";
import I152_duotone from "./phosphor/seal-duotone.svg?component-solid";
import I152_fill from "./phosphor/seal-fill.svg?component-solid";
import I152_regular from "./phosphor/seal-regular.svg?component-solid";
import I184_duotone from "./phosphor/share-network-duotone.svg?component-solid";
import I184_fill from "./phosphor/share-network-fill.svg?component-solid";
import I184_regular from "./phosphor/share-network-regular.svg?component-solid";
import I70_duotone from "./phosphor/shield-check-duotone.svg?component-solid";
import I70_fill from "./phosphor/shield-check-fill.svg?component-solid";
import I70_regular from "./phosphor/shield-check-regular.svg?component-solid";
import I124_duotone from "./phosphor/shield-duotone.svg?component-solid";
import I124_fill from "./phosphor/shield-fill.svg?component-solid";
import I124_regular from "./phosphor/shield-regular.svg?component-solid";
import I150_duotone from "./phosphor/shopping-bag-duotone.svg?component-solid";
import I150_fill from "./phosphor/shopping-bag-fill.svg?component-solid";
import I150_regular from "./phosphor/shopping-bag-regular.svg?component-solid";
import I98_duotone from "./phosphor/sign-in-duotone.svg?component-solid";
import I98_fill from "./phosphor/sign-in-fill.svg?component-solid";
import I98_regular from "./phosphor/sign-in-regular.svg?component-solid";
import I97_duotone from "./phosphor/sign-out-duotone.svg?component-solid";
import I97_fill from "./phosphor/sign-out-fill.svg?component-solid";
import I97_regular from "./phosphor/sign-out-regular.svg?component-solid";
import I107_duotone from "./phosphor/sliders-horizontal-duotone.svg?component-solid";
import I107_fill from "./phosphor/sliders-horizontal-fill.svg?component-solid";
import I107_regular from "./phosphor/sliders-horizontal-regular.svg?component-solid";
import I32_duotone from "./phosphor/smiley-duotone.svg?component-solid";
import I32_fill from "./phosphor/smiley-fill.svg?component-solid";
import I32_regular from "./phosphor/smiley-regular.svg?component-solid";
import I165_duotone from "./phosphor/sort-ascending-duotone.svg?component-solid";
import I165_fill from "./phosphor/sort-ascending-fill.svg?component-solid";
import I165_regular from "./phosphor/sort-ascending-regular.svg?component-solid";
import I147_duotone from "./phosphor/sparkle-duotone.svg?component-solid";
import I147_fill from "./phosphor/sparkle-fill.svg?component-solid";
import I147_regular from "./phosphor/sparkle-regular.svg?component-solid";
import I22_duotone from "./phosphor/speaker-high-duotone.svg?component-solid";
import I22_fill from "./phosphor/speaker-high-fill.svg?component-solid";
import I22_regular from "./phosphor/speaker-high-regular.svg?component-solid";
import I115_duotone from "./phosphor/speaker-low-duotone.svg?component-solid";
import I115_fill from "./phosphor/speaker-low-fill.svg?component-solid";
import I115_regular from "./phosphor/speaker-low-regular.svg?component-solid";
import I20_duotone from "./phosphor/speaker-slash-duotone.svg?component-solid";
import I20_fill from "./phosphor/speaker-slash-fill.svg?component-solid";
import I20_regular from "./phosphor/speaker-slash-regular.svg?component-solid";
import I48_duotone from "./phosphor/square-duotone.svg?component-solid";
import I48_fill from "./phosphor/square-fill.svg?component-solid";
import I48_regular from "./phosphor/square-regular.svg?component-solid";
import I169_duotone from "./phosphor/squares-four-duotone.svg?component-solid";
import I169_fill from "./phosphor/squares-four-fill.svg?component-solid";
import I169_regular from "./phosphor/squares-four-regular.svg?component-solid";
import I111_duotone from "./phosphor/star-duotone.svg?component-solid";
import I111_fill from "./phosphor/star-fill.svg?component-solid";
import I111_regular from "./phosphor/star-regular.svg?component-solid";
import I122_duotone from "./phosphor/stop-duotone.svg?component-solid";
import I122_fill from "./phosphor/stop-fill.svg?component-solid";
import I122_regular from "./phosphor/stop-regular.svg?component-solid";
import I149_duotone from "./phosphor/storefront-duotone.svg?component-solid";
import I149_fill from "./phosphor/storefront-fill.svg?component-solid";
import I149_regular from "./phosphor/storefront-regular.svg?component-solid";
import I106_duotone from "./phosphor/sun-duotone.svg?component-solid";
import I106_fill from "./phosphor/sun-fill.svg?component-solid";
import I106_regular from "./phosphor/sun-regular.svg?component-solid";
import I137_duotone from "./phosphor/terminal-duotone.svg?component-solid";
import I137_fill from "./phosphor/terminal-fill.svg?component-solid";
import I137_regular from "./phosphor/terminal-regular.svg?component-solid";
import I161_duotone from "./phosphor/text-aa-duotone.svg?component-solid";
import I161_fill from "./phosphor/text-aa-fill.svg?component-solid";
import I161_regular from "./phosphor/text-aa-regular.svg?component-solid";
import I128_duotone from "./phosphor/text-b-duotone.svg?component-solid";
import I128_fill from "./phosphor/text-b-fill.svg?component-solid";
import I128_regular from "./phosphor/text-b-regular.svg?component-solid";
import I129_duotone from "./phosphor/text-italic-duotone.svg?component-solid";
import I129_fill from "./phosphor/text-italic-fill.svg?component-solid";
import I129_regular from "./phosphor/text-italic-regular.svg?component-solid";
import I159_duotone from "./phosphor/text-strikethrough-duotone.svg?component-solid";
import I159_fill from "./phosphor/text-strikethrough-fill.svg?component-solid";
import I159_regular from "./phosphor/text-strikethrough-regular.svg?component-solid";
import I160_duotone from "./phosphor/text-t-duotone.svg?component-solid";
import I160_fill from "./phosphor/text-t-fill.svg?component-solid";
import I160_regular from "./phosphor/text-t-regular.svg?component-solid";
import I130_duotone from "./phosphor/text-underline-duotone.svg?component-solid";
import I130_fill from "./phosphor/text-underline-fill.svg?component-solid";
import I130_regular from "./phosphor/text-underline-regular.svg?component-solid";
import I83_duotone from "./phosphor/timer-duotone.svg?component-solid";
import I83_fill from "./phosphor/timer-fill.svg?component-solid";
import I83_regular from "./phosphor/timer-regular.svg?component-solid";
import I114_duotone from "./phosphor/translate-duotone.svg?component-solid";
import I114_fill from "./phosphor/translate-fill.svg?component-solid";
import I114_regular from "./phosphor/translate-regular.svg?component-solid";
import I13_duotone from "./phosphor/trash-duotone.svg?component-solid";
import I13_fill from "./phosphor/trash-fill.svg?component-solid";
import I13_regular from "./phosphor/trash-regular.svg?component-solid";
import I65_duotone from "./phosphor/tray-duotone.svg?component-solid";
import I65_fill from "./phosphor/tray-fill.svg?component-solid";
import I65_regular from "./phosphor/tray-regular.svg?component-solid";
import I31_duotone from "./phosphor/upload-simple-duotone.svg?component-solid";
import I31_fill from "./phosphor/upload-simple-fill.svg?component-solid";
import I31_regular from "./phosphor/upload-simple-regular.svg?component-solid";
import I7_duotone from "./phosphor/user-circle-duotone.svg?component-solid";
import I7_fill from "./phosphor/user-circle-fill.svg?component-solid";
import I7_regular from "./phosphor/user-circle-regular.svg?component-solid";
import I8_duotone from "./phosphor/user-duotone.svg?component-solid";
import I8_fill from "./phosphor/user-fill.svg?component-solid";
import I127_duotone from "./phosphor/user-focus-duotone.svg?component-solid";
import I127_fill from "./phosphor/user-focus-fill.svg?component-solid";
import I127_regular from "./phosphor/user-focus-regular.svg?component-solid";
import I126_duotone from "./phosphor/user-gear-duotone.svg?component-solid";
import I126_fill from "./phosphor/user-gear-fill.svg?component-solid";
import I126_regular from "./phosphor/user-gear-regular.svg?component-solid";
import I10_duotone from "./phosphor/user-minus-duotone.svg?component-solid";
import I10_fill from "./phosphor/user-minus-fill.svg?component-solid";
import I10_regular from "./phosphor/user-minus-regular.svg?component-solid";
import I9_duotone from "./phosphor/user-plus-duotone.svg?component-solid";
import I9_fill from "./phosphor/user-plus-fill.svg?component-solid";
import I9_regular from "./phosphor/user-plus-regular.svg?component-solid";
import I8_regular from "./phosphor/user-regular.svg?component-solid";
import I1_duotone from "./phosphor/users-duotone.svg?component-solid";
import I1_fill from "./phosphor/users-fill.svg?component-solid";
import I1_regular from "./phosphor/users-regular.svg?component-solid";
import I2_duotone from "./phosphor/users-three-duotone.svg?component-solid";
import I2_fill from "./phosphor/users-three-fill.svg?component-solid";
import I2_regular from "./phosphor/users-three-regular.svg?component-solid";
import I25_duotone from "./phosphor/video-camera-duotone.svg?component-solid";
import I25_fill from "./phosphor/video-camera-fill.svg?component-solid";
import I25_regular from "./phosphor/video-camera-regular.svg?component-solid";
import I26_duotone from "./phosphor/video-camera-slash-duotone.svg?component-solid";
import I26_fill from "./phosphor/video-camera-slash-fill.svg?component-solid";
import I26_regular from "./phosphor/video-camera-slash-regular.svg?component-solid";
import I76_duotone from "./phosphor/warning-circle-duotone.svg?component-solid";
import I76_fill from "./phosphor/warning-circle-fill.svg?component-solid";
import I76_regular from "./phosphor/warning-circle-regular.svg?component-solid";
import I77_duotone from "./phosphor/warning-duotone.svg?component-solid";
import I77_fill from "./phosphor/warning-fill.svg?component-solid";
import I78_duotone from "./phosphor/warning-octagon-duotone.svg?component-solid";
import I78_fill from "./phosphor/warning-octagon-fill.svg?component-solid";
import I78_regular from "./phosphor/warning-octagon-regular.svg?component-solid";
import I77_regular from "./phosphor/warning-regular.svg?component-solid";
import I38_duotone from "./phosphor/waveform-duotone.svg?component-solid";
import I38_fill from "./phosphor/waveform-fill.svg?component-solid";
import I38_regular from "./phosphor/waveform-regular.svg?component-solid";
import I108_duotone from "./phosphor/webhooks-logo-duotone.svg?component-solid";
import I108_fill from "./phosphor/webhooks-logo-fill.svg?component-solid";
import I108_regular from "./phosphor/webhooks-logo-regular.svg?component-solid";
import I143_duotone from "./phosphor/wifi-high-duotone.svg?component-solid";
import I143_fill from "./phosphor/wifi-high-fill.svg?component-solid";
import I143_regular from "./phosphor/wifi-high-regular.svg?component-solid";
import I144_duotone from "./phosphor/wifi-slash-duotone.svg?component-solid";
import I144_fill from "./phosphor/wifi-slash-fill.svg?component-solid";
import I144_regular from "./phosphor/wifi-slash-regular.svg?component-solid";
import I136_duotone from "./phosphor/wrench-duotone.svg?component-solid";
import I136_fill from "./phosphor/wrench-fill.svg?component-solid";
import I136_regular from "./phosphor/wrench-regular.svg?component-solid";
import I44_duotone from "./phosphor/x-circle-duotone.svg?component-solid";
import I44_fill from "./phosphor/x-circle-fill.svg?component-solid";
import I44_regular from "./phosphor/x-circle-regular.svg?component-solid";
import I43_duotone from "./phosphor/x-duotone.svg?component-solid";
import I43_fill from "./phosphor/x-fill.svg?component-solid";
import I43_regular from "./phosphor/x-regular.svg?component-solid";

import CloudExpressive from "./phosphor/cloud-duotone.svg?component-solid";
import CloudFilled from "./phosphor/cloud-fill.svg?component-solid";
import CloudOutline from "./phosphor/cloud-regular.svg?component-solid";

export const iconRegistry = {
  cloud: {
    outline: CloudOutline,
    filled: CloudFilled,
    expressive: CloudExpressive,
  },
  house: { outline: I0_regular, filled: I0_fill, expressive: I0_duotone },
  users: { outline: I1_regular, filled: I1_fill, expressive: I1_duotone },
  "users-three": {
    outline: I2_regular,
    filled: I2_fill,
    expressive: I2_duotone,
  },
  "gear-six": { outline: I3_regular, filled: I3_fill, expressive: I3_duotone },
  "magnifying-glass": {
    outline: I4_regular,
    filled: I4_fill,
    expressive: I4_duotone,
  },
  bell: { outline: I5_regular, filled: I5_fill, expressive: I5_duotone },
  "bell-slash": {
    outline: I6_regular,
    filled: I6_fill,
    expressive: I6_duotone,
  },
  "user-circle": {
    outline: I7_regular,
    filled: I7_fill,
    expressive: I7_duotone,
  },
  user: { outline: I8_regular, filled: I8_fill, expressive: I8_duotone },
  "user-plus": { outline: I9_regular, filled: I9_fill, expressive: I9_duotone },
  "user-minus": {
    outline: I10_regular,
    filled: I10_fill,
    expressive: I10_duotone,
  },
  "pencil-simple": {
    outline: I11_regular,
    filled: I11_fill,
    expressive: I11_duotone,
  },
  "note-pencil": {
    outline: I12_regular,
    filled: I12_fill,
    expressive: I12_duotone,
  },
  trash: { outline: I13_regular, filled: I13_fill, expressive: I13_duotone },
  "push-pin": {
    outline: I14_regular,
    filled: I14_fill,
    expressive: I14_duotone,
  },
  link: { outline: I15_regular, filled: I15_fill, expressive: I15_duotone },
  copy: { outline: I16_regular, filled: I16_fill, expressive: I16_duotone },
  microphone: {
    outline: I17_regular,
    filled: I17_fill,
    expressive: I17_duotone,
  },
  "microphone-slash": {
    outline: I18_regular,
    filled: I18_fill,
    expressive: I18_duotone,
  },
  headphones: {
    outline: I19_regular,
    filled: I19_fill,
    expressive: I19_duotone,
  },
  "speaker-slash": {
    outline: I20_regular,
    filled: I20_fill,
    expressive: I20_duotone,
  },
  headset: { outline: I21_regular, filled: I21_fill, expressive: I21_duotone },
  "speaker-high": {
    outline: I22_regular,
    filled: I22_fill,
    expressive: I22_duotone,
  },
  phone: { outline: I23_regular, filled: I23_fill, expressive: I23_duotone },
  "phone-disconnect": {
    outline: I24_regular,
    filled: I24_fill,
    expressive: I24_duotone,
  },
  "video-camera": {
    outline: I25_regular,
    filled: I25_fill,
    expressive: I25_duotone,
  },
  "video-camera-slash": {
    outline: I26_regular,
    filled: I26_fill,
    expressive: I26_duotone,
  },
  screencast: {
    outline: I27_regular,
    filled: I27_fill,
    expressive: I27_duotone,
  },
  monitor: { outline: I28_regular, filled: I28_fill, expressive: I28_duotone },
  // screen share: monitor with an up arrow instead of the Android-style cast glyph
  "monitor-arrow-up": {
    outline: IMonUp_regular,
    filled: IMonUp_fill,
    expressive: IMonUp_duotone,
  },
  paperclip: {
    outline: I29_regular,
    filled: I29_fill,
    expressive: I29_duotone,
  },
  "download-simple": {
    outline: I30_regular,
    filled: I30_fill,
    expressive: I30_duotone,
  },
  "upload-simple": {
    outline: I31_regular,
    filled: I31_fill,
    expressive: I31_duotone,
  },
  smiley: { outline: I32_regular, filled: I32_fill, expressive: I32_duotone },
  "arrow-bend-up-left": {
    outline: I33_regular,
    filled: I33_fill,
    expressive: I33_duotone,
  },
  "paper-plane-tilt": {
    outline: I34_regular,
    filled: I34_fill,
    expressive: I34_duotone,
  },
  // duotone hash fills its centre square, which reads as a stray box at 16–22px
  hash: { outline: I35_regular, filled: I35_fill, expressive: I35_regular },
  "chat-circle": {
    outline: I36_regular,
    filled: I36_fill,
    expressive: I36_duotone,
  },
  "chats-circle": {
    outline: I37_regular,
    filled: I37_fill,
    expressive: I37_duotone,
  },
  waveform: { outline: I38_regular, filled: I38_fill, expressive: I38_duotone },
  // An open plus has no interior: keep the expressive form free of a decorative square.
  plus: { outline: I39_regular, filled: I39_fill, expressive: I39_regular },
  "plus-circle": {
    outline: I40_regular,
    filled: I40_fill,
    expressive: I40_duotone,
  },
  "plus-square": {
    outline: I41_regular,
    filled: I41_fill,
    expressive: I41_duotone,
  },
  minus: { outline: I42_regular, filled: I42_fill, expressive: I42_duotone },
  x: { outline: I43_regular, filled: I43_fill, expressive: I43_duotone },
  "x-circle": {
    outline: I44_regular,
    filled: I44_fill,
    expressive: I44_duotone,
  },
  check: { outline: I45_regular, filled: I45_fill, expressive: I45_duotone },
  "check-circle": {
    outline: I46_regular,
    filled: I46_fill,
    expressive: I46_duotone,
  },
  "check-square": {
    outline: I47_regular,
    filled: I47_fill,
    expressive: I47_duotone,
  },
  square: { outline: I48_regular, filled: I48_fill, expressive: I48_duotone },
  "arrow-left": {
    outline: I49_regular,
    filled: I49_fill,
    expressive: I49_duotone,
  },
  "arrow-right": {
    outline: I50_regular,
    filled: I50_fill,
    expressive: I50_duotone,
  },
  "arrow-up-left": {
    outline: I51_regular,
    filled: I51_fill,
    expressive: I51_duotone,
  },
  "caret-down": {
    outline: I52_regular,
    filled: I52_fill,
    expressive: I52_duotone,
  },
  "caret-up": {
    outline: I53_regular,
    filled: I53_fill,
    expressive: I53_duotone,
  },
  "caret-right": {
    outline: I54_regular,
    filled: I54_fill,
    expressive: I54_duotone,
  },
  "caret-left": {
    outline: I55_regular,
    filled: I55_fill,
    expressive: I55_duotone,
  },
  "dots-three": {
    outline: I56_regular,
    filled: I56_fill,
    expressive: I56_duotone,
  },
  "dots-three-vertical": {
    outline: I57_regular,
    filled: I57_fill,
    expressive: I57_duotone,
  },
  "arrows-out-line-vertical": {
    outline: I58_regular,
    filled: I58_fill,
    expressive: I58_duotone,
  },
  "arrows-in-line-vertical": {
    outline: I59_regular,
    filled: I59_fill,
    expressive: I59_duotone,
  },
  "arrows-out": {
    outline: I60_regular,
    filled: I60_fill,
    expressive: I60_duotone,
  },
  "arrows-in": {
    outline: I61_regular,
    filled: I61_fill,
    expressive: I61_duotone,
  },
  "arrow-square-out": {
    outline: I62_regular,
    filled: I62_fill,
    expressive: I62_duotone,
  },
  notebook: { outline: I63_regular, filled: I63_fill, expressive: I63_duotone },
  "file-text": {
    outline: I64_regular,
    filled: I64_fill,
    expressive: I64_duotone,
  },
  tray: { outline: I65_regular, filled: I65_fill, expressive: I65_duotone },
  compass: { outline: I66_regular, filled: I66_fill, expressive: I66_duotone },
  globe: { outline: I67_regular, filled: I67_fill, expressive: I67_duotone },
  prohibit: { outline: I68_regular, filled: I68_fill, expressive: I68_duotone },
  "minus-circle": {
    outline: I69_regular,
    filled: I69_fill,
    expressive: I69_duotone,
  },
  "shield-check": {
    outline: I70_regular,
    filled: I70_fill,
    expressive: I70_duotone,
  },
  "lock-simple": {
    outline: I71_regular,
    filled: I71_fill,
    expressive: I71_duotone,
  },
  "lock-simple-open": {
    outline: I72_regular,
    filled: I72_fill,
    expressive: I72_duotone,
  },
  key: { outline: I73_regular, filled: I73_fill, expressive: I73_duotone },
  password: { outline: I74_regular, filled: I74_fill, expressive: I74_duotone },
  info: { outline: I75_regular, filled: I75_fill, expressive: I75_duotone },
  "warning-circle": {
    outline: I76_regular,
    filled: I76_fill,
    expressive: I76_duotone,
  },
  warning: { outline: I77_regular, filled: I77_fill, expressive: I77_duotone },
  "warning-octagon": {
    outline: I78_regular,
    filled: I78_fill,
    expressive: I78_duotone,
  },
  flag: { outline: I79_regular, filled: I79_fill, expressive: I79_duotone },
  gavel: { outline: I80_regular, filled: I80_fill, expressive: I80_duotone },
  eye: { outline: I81_regular, filled: I81_fill, expressive: I81_duotone },
  "eye-slash": {
    outline: I82_regular,
    filled: I82_fill,
    expressive: I82_duotone,
  },
  timer: { outline: I83_regular, filled: I83_fill, expressive: I83_duotone },
  clock: { outline: I84_regular, filled: I84_fill, expressive: I84_duotone },
  hourglass: {
    outline: I85_regular,
    filled: I85_fill,
    expressive: I85_duotone,
  },
  "identification-badge": {
    outline: I86_regular,
    filled: I86_fill,
    expressive: I86_duotone,
  },
  "identification-card": {
    outline: I87_regular,
    filled: I87_fill,
    expressive: I87_duotone,
  },
  at: { outline: I88_regular, filled: I88_fill, expressive: I88_duotone },
  envelope: { outline: I89_regular, filled: I89_fill, expressive: I89_duotone },
  desktop: { outline: I90_regular, filled: I90_fill, expressive: I90_duotone },
  keyboard: { outline: I91_regular, filled: I91_fill, expressive: I91_duotone },
  "grid-nine": {
    outline: I92_regular,
    filled: I92_fill,
    expressive: I92_duotone,
  },
  list: { outline: I93_regular, filled: I93_fill, expressive: I93_duotone },
  // GIF is a lettermark: keep it unboxed in every theme icon style.
  gif: { outline: I94_regular, filled: I94_regular, expressive: I94_regular },
  image: { outline: I95_regular, filled: I95_fill, expressive: I95_duotone },
  palette: { outline: I96_regular, filled: I96_fill, expressive: I96_duotone },
  "sign-out": {
    outline: I97_regular,
    filled: I97_fill,
    expressive: I97_duotone,
  },
  "sign-in": {
    outline: I98_regular,
    filled: I98_fill,
    expressive: I98_duotone,
  },
  "arrow-clockwise": {
    outline: I99_regular,
    filled: I99_fill,
    expressive: I99_duotone,
  },
  "arrows-clockwise": {
    outline: I100_regular,
    filled: I100_fill,
    expressive: I100_duotone,
  },
  question: {
    outline: I101_regular,
    filled: I101_fill,
    expressive: I101_duotone,
  },
  "magnifying-glass-plus": {
    outline: I102_regular,
    filled: I102_fill,
    expressive: I102_duotone,
  },
  "magnifying-glass-minus": {
    outline: I103_regular,
    filled: I103_fill,
    expressive: I103_duotone,
  },
  "hand-waving": {
    outline: I104_regular,
    filled: I104_fill,
    expressive: I104_duotone,
  },
  leaf: { outline: I105_regular, filled: I105_fill, expressive: I105_duotone },
  sun: { outline: I106_regular, filled: I106_fill, expressive: I106_duotone },
  "sliders-horizontal": {
    outline: I107_regular,
    filled: I107_fill,
    expressive: I107_duotone,
  },
  "webhooks-logo": {
    outline: I108_regular,
    filled: I108_fill,
    expressive: I108_duotone,
  },
  folder: {
    outline: I109_regular,
    filled: I109_fill,
    expressive: I109_duotone,
  },
  "folder-open": {
    outline: I110_regular,
    filled: I110_fill,
    expressive: I110_duotone,
  },
  star: { outline: I111_regular, filled: I111_fill, expressive: I111_duotone },
  heart: { outline: I112_regular, filled: I112_fill, expressive: I112_duotone },
  "bookmark-simple": {
    outline: I113_regular,
    filled: I113_fill,
    expressive: I113_duotone,
  },
  translate: {
    outline: I114_regular,
    filled: I114_fill,
    expressive: I114_duotone,
  },
  "speaker-low": {
    outline: I115_regular,
    filled: I115_fill,
    expressive: I115_duotone,
  },
  funnel: {
    outline: I116_regular,
    filled: I116_fill,
    expressive: I116_duotone,
  },
  "floppy-disk": {
    outline: I117_regular,
    filled: I117_fill,
    expressive: I117_duotone,
  },
  "cloud-arrow-down": {
    outline: I118_regular,
    filled: I118_fill,
    expressive: I118_duotone,
  },
  "clock-counter-clockwise": {
    outline: I119_regular,
    filled: I119_fill,
    expressive: I119_duotone,
  },
  play: { outline: I120_regular, filled: I120_fill, expressive: I120_duotone },
  pause: { outline: I121_regular, filled: I121_fill, expressive: I121_duotone },
  stop: { outline: I122_regular, filled: I122_fill, expressive: I122_duotone },
  "arrow-counter-clockwise": {
    outline: I123_regular,
    filled: I123_fill,
    expressive: I123_duotone,
  },
  shield: {
    outline: I124_regular,
    filled: I124_fill,
    expressive: I124_duotone,
  },
  "seal-check": {
    outline: I125_regular,
    filled: I125_fill,
    expressive: I125_duotone,
  },
  "user-gear": {
    outline: I126_regular,
    filled: I126_fill,
    expressive: I126_duotone,
  },
  "user-focus": {
    outline: I127_regular,
    filled: I127_fill,
    expressive: I127_duotone,
  },
  "text-b": {
    outline: I128_regular,
    filled: I128_fill,
    expressive: I128_duotone,
  },
  "text-italic": {
    outline: I129_regular,
    filled: I129_fill,
    expressive: I129_duotone,
  },
  "text-underline": {
    outline: I130_regular,
    filled: I130_fill,
    expressive: I130_duotone,
  },
  quotes: {
    outline: I131_regular,
    filled: I131_fill,
    expressive: I131_duotone,
  },
  code: { outline: I132_regular, filled: I132_fill, expressive: I132_duotone },
  bug: { outline: I133_regular, filled: I133_fill, expressive: I133_duotone },
  "currency-circle-dollar": {
    outline: I134_regular,
    filled: I134_fill,
    expressive: I134_duotone,
  },
  flask: { outline: I135_regular, filled: I135_fill, expressive: I135_duotone },
  wrench: {
    outline: I136_regular,
    filled: I136_fill,
    expressive: I136_duotone,
  },
  terminal: {
    outline: I137_regular,
    filled: I137_fill,
    expressive: I137_duotone,
  },
  "radio-button": {
    outline: I138_regular,
    filled: I138_fill,
    expressive: I138_duotone,
  },
  circle: {
    outline: I139_regular,
    filled: I139_fill,
    expressive: I139_duotone,
  },
  "music-note": {
    outline: I140_regular,
    filled: I140_fill,
    expressive: I140_duotone,
  },
  file: { outline: I141_regular, filled: I141_fill, expressive: I141_duotone },
  "device-mobile": {
    outline: I142_regular,
    filled: I142_fill,
    expressive: I142_duotone,
  },
  "wifi-high": {
    outline: I143_regular,
    filled: I143_fill,
    expressive: I143_duotone,
  },
  "wifi-slash": {
    outline: I144_regular,
    filled: I144_fill,
    expressive: I144_duotone,
  },
  "cell-signal-full": {
    outline: I145_regular,
    filled: I145_fill,
    expressive: I145_duotone,
  },
  lightning: {
    outline: I146_regular,
    filled: I146_fill,
    expressive: I146_duotone,
  },
  sparkle: {
    outline: I147_regular,
    filled: I147_fill,
    expressive: I147_duotone,
  },
  "rocket-launch": {
    outline: I148_regular,
    filled: I148_fill,
    expressive: I148_duotone,
  },
  storefront: {
    outline: I149_regular,
    filled: I149_fill,
    expressive: I149_duotone,
  },
  "shopping-bag": {
    outline: I150_regular,
    filled: I150_fill,
    expressive: I150_duotone,
  },
  archive: {
    outline: I151_regular,
    filled: I151_fill,
    expressive: I151_duotone,
  },
  seal: { outline: I152_regular, filled: I152_fill, expressive: I152_duotone },
  gift: { outline: I153_regular, filled: I153_fill, expressive: I153_duotone },
  confetti: {
    outline: I154_regular,
    filled: I154_fill,
    expressive: I154_duotone,
  },
  "game-controller": {
    outline: I155_regular,
    filled: I155_fill,
    expressive: I155_duotone,
  },
  "list-checks": {
    outline: I156_regular,
    filled: I156_fill,
    expressive: I156_duotone,
  },
  "list-bullets": {
    outline: I157_regular,
    filled: I157_fill,
    expressive: I157_duotone,
  },
  "list-numbers": {
    outline: I158_regular,
    filled: I158_fill,
    expressive: I158_duotone,
  },
  "text-strikethrough": {
    outline: I159_regular,
    filled: I159_fill,
    expressive: I159_duotone,
  },
  "text-t": {
    outline: I160_regular,
    filled: I160_fill,
    expressive: I160_duotone,
  },
  "text-aa": {
    outline: I161_regular,
    filled: I161_fill,
    expressive: I161_duotone,
  },
  "person-arms-spread": {
    outline: I162_regular,
    filled: I162_fill,
    expressive: I162_duotone,
  },
  moon: { outline: I163_regular, filled: I163_fill, expressive: I163_duotone },
  "circle-half": {
    outline: I164_regular,
    filled: I164_fill,
    expressive: I164_duotone,
  },
  "sort-ascending": {
    outline: I165_regular,
    filled: I165_fill,
    expressive: I165_duotone,
  },
  "arrows-down-up": {
    outline: I166_regular,
    filled: I166_fill,
    expressive: I166_duotone,
  },
  "dots-six-vertical": {
    outline: I167_regular,
    filled: I167_fill,
    expressive: I167_duotone,
  },
  "dots-six": {
    outline: I168_regular,
    filled: I168_fill,
    expressive: I168_duotone,
  },
  "squares-four": {
    outline: I169_regular,
    filled: I169_fill,
    expressive: I169_duotone,
  },
  "arrow-bend-up-right": {
    outline: I170_regular,
    filled: I170_fill,
    expressive: I170_duotone,
  },
  "arrow-u-up-left": {
    outline: I171_regular,
    filled: I171_fill,
    expressive: I171_duotone,
  },
  "arrow-u-up-right": {
    outline: I172_regular,
    filled: I172_fill,
    expressive: I172_duotone,
  },
  cake: { outline: I173_regular, filled: I173_fill, expressive: I173_duotone },
  books: { outline: I174_regular, filled: I174_fill, expressive: I174_duotone },
  robot: { outline: I175_regular, filled: I175_fill, expressive: I175_duotone },
  coin: { outline: I176_regular, filled: I176_fill, expressive: I176_duotone },
  calendar: {
    outline: I177_regular,
    filled: I177_fill,
    expressive: I177_duotone,
  },
  "chat-circle-dots": {
    outline: I178_regular,
    filled: I178_fill,
    expressive: I178_duotone,
  },
  "paint-brush": {
    outline: I179_regular,
    filled: I179_fill,
    expressive: I179_duotone,
  },
  megaphone: {
    outline: I180_regular,
    filled: I180_fill,
    expressive: I180_duotone,
  },
  cpu: { outline: I181_regular, filled: I181_fill, expressive: I181_duotone },
  "chat-centered-text": {
    outline: I182_regular,
    filled: I182_fill,
    expressive: I182_duotone,
  },
  medal: { outline: I183_regular, filled: I183_fill, expressive: I183_duotone },
  "share-network": {
    outline: I184_regular,
    filled: I184_fill,
    expressive: I184_duotone,
  },
  "folder-plus": {
    outline: I185_regular,
    filled: I185_fill,
    expressive: I185_duotone,
  },
  "folder-minus": {
    outline: I186_regular,
    filled: I186_fill,
    expressive: I186_duotone,
  },
  "bell-ringing": {
    outline: I187_regular,
    filled: I187_fill,
    expressive: I187_duotone,
  },
  "caret-double-left": {
    outline: I188_regular,
    filled: I188_fill,
    expressive: I188_duotone,
  },
  "caret-double-right": {
    outline: I189_regular,
    filled: I189_fill,
    expressive: I189_duotone,
  },
} as const;

export type IconName = keyof typeof iconRegistry;

export const symbolNames: Record<string, IconName> = {
  cancel_presentation: "monitor",
  web_asset: "desktop",
  groups_2: "users-three",
  spellcheck: "text-aa",
  speed: "lightning",
  cloud: "cloud",
  timer_off: "timer",
  no_sound: "speaker-slash",
  sentiment_content: "smiley",
  home: "house",
  group: "users",
  groups: "users-three",
  settings: "gear-six",
  search: "magnifying-glass",
  notifications: "bell",
  notifications_off: "bell-slash",
  account_circle: "user-circle",
  person: "user",
  person_add: "user-plus",
  person_add_alt: "user-plus",
  person_add_alt_1: "user-plus",
  person_remove: "user-minus",
  edit: "pencil-simple",
  edit_note: "note-pencil",
  delete: "trash",
  push_pin: "push-pin",
  pin: "push-pin",
  link: "link",
  content_copy: "copy",
  mic: "microphone",
  mic_off: "microphone-slash",
  headset: "headphones",
  headset_off: "speaker-slash",
  headset_mic: "headset",
  volume_up: "speaker-high",
  volume_off: "speaker-slash",
  speaker: "speaker-high",
  call: "phone",
  call_end: "phone-disconnect",
  camera_video: "video-camera",
  videocam: "video-camera",
  videocam_off: "video-camera-slash",
  screen_share: "monitor-arrow-up",
  stop_screen_share: "monitor",
  attach_file: "paperclip",
  attachment: "paperclip",
  download: "download-simple",
  upload: "upload-simple",
  mood: "smiley",
  face: "smiley",
  add_reaction: "smiley",
  reply: "arrow-bend-up-left",
  send: "paper-plane-tilt",
  tag: "hash",
  chat: "chat-circle",
  chat_bubble: "chat-circle",
  forum: "chats-circle",
  voice_chat: "waveform",
  add: "plus",
  add_circle_outline: "plus-circle",
  add_circle: "plus-circle",
  add_box: "plus-square",
  remove: "minus",
  close: "x",
  cancel: "x-circle",
  check: "check",
  check_circle: "check-circle",
  done: "check",
  check_box: "check-square",
  check_box_outline_blank: "square",
  arrow_back: "arrow-left",
  arrow_forward: "arrow-right",
  arrow_top_left: "arrow-up-left",
  keyboard_arrow_down: "caret-down",
  keyboard_arrow_up: "caret-up",
  expand_more: "caret-down",
  expand_less: "caret-up",
  chevron_right: "caret-right",
  chevron_left: "caret-left",
  more_horiz: "dots-three",
  more_vert: "dots-three-vertical",
  unfold_more: "arrows-out-line-vertical",
  unfold_less: "arrows-in-line-vertical",
  fullscreen: "arrows-out",
  fullscreen_exit: "arrows-in",
  close_fullscreen: "arrows-in",
  open_in_full: "arrows-out",
  open_in_new: "arrow-square-out",
  note_stack: "notebook",
  description: "file-text",
  all_inbox: "tray",
  explore: "compass",
  public: "globe",
  language: "globe",
  block: "prohibit",
  do_not_disturb_on: "minus-circle",
  admin_panel_settings: "shield-check",
  security: "shield-check",
  lock: "lock-simple",
  lock_open: "lock-simple-open",
  key: "key",
  password: "password",
  info: "info",
  error: "warning-circle",
  warning: "warning",
  report: "warning-octagon",
  flag: "flag",
  gavel: "gavel",
  visibility: "eye",
  visibility_off: "eye-slash",
  timer: "timer",
  schedule: "clock",
  hourglass_empty: "hourglass",
  badge: "identification-badge",
  assignment_ind: "identification-card",
  contact_page: "identification-card",
  alternate_email: "at",
  mail: "envelope",
  email: "envelope",
  desktop_windows: "desktop",
  keyboard: "keyboard",
  grid_3x3: "grid-nine",
  view_list: "list",
  menu: "list",
  gif: "gif",
  image: "image",
  palette: "palette",
  logout: "sign-out",
  exit_to_app: "sign-out",
  login: "sign-in",
  refresh: "arrow-clockwise",
  sync: "arrows-clockwise",
  help: "question",
  help_outline: "question",
  zoom_in: "magnifying-glass-plus",
  zoom_out: "magnifying-glass-minus",
  waving_hand: "hand-waving",
  spa: "leaf",
  brightness_alert: "sun",
  page_info: "sliders-horizontal",
  webhook: "webhooks-logo",
  folder: "folder",
  folder_open: "folder-open",
  star: "star",
  favorite: "heart",
  favorite_border: "heart",
  bookmark: "bookmark-simple",
  translate: "translate",
  volume_down: "speaker-low",
  tune: "sliders-horizontal",
  filter_list: "funnel",
  save: "floppy-disk",
  cloud_download: "cloud-arrow-down",
  history: "clock-counter-clockwise",
  play_arrow: "play",
  pause: "pause",
  stop: "stop",
  replay: "arrow-counter-clockwise",
  shield: "shield",
  verified: "seal-check",
  verified_user: "shield-check",
  person_off: "user-minus",
  person_outline: "user",
  manage_accounts: "user-gear",
  manage_search: "magnifying-glass",
  person_search: "user-focus",
  emoji_emotions: "smiley",
  sentiment_satisfied: "smiley",
  format_bold: "text-b",
  format_italic: "text-italic",
  format_underlined: "text-underline",
  format_quote: "quotes",
  code: "code",
  arrow_drop_down: "caret-down",
  arrow_drop_up: "caret-up",
  keyboard_arrow_right: "caret-right",
  keyboard_arrow_left: "caret-left",
  expand: "arrows-out",
  bug_report: "bug",
  paid: "currency-circle-dollar",
  science: "flask",
  construction: "wrench",
  build: "wrench",
  terminal: "terminal",
  remove_circle: "minus-circle",
  remove_circle_outline: "minus-circle",
  radio_button_checked: "radio-button",
  radio_button_unchecked: "circle",
  music_note: "music-note",
  audiotrack: "music-note",
  insert_drive_file: "file",
  insert_photo: "image",
  smartphone: "device-mobile",
  phone_android: "device-mobile",
  wifi: "wifi-high",
  wifi_off: "wifi-slash",
  signal_cellular_alt: "cell-signal-full",
  bolt: "lightning",
  flash_on: "lightning",
  auto_awesome: "sparkle",
  rocket_launch: "rocket-launch",
  store: "storefront",
  shopping_bag: "shopping-bag",
  inventory_2: "archive",
  new_releases: "seal",
  redeem: "gift",
  celebration: "confetti",
  sports_esports: "game-controller",
  list: "list",
  list_alt: "list-checks",
  format_list_bulleted: "list-bullets",
  format_list_numbered: "list-numbers",
  format_strikethrough: "text-strikethrough",
  text_fields: "text-t",
  text_format: "text-t",
  format_size: "text-aa",
  accessibility: "person-arms-spread",
  accessibility_new: "person-arms-spread",
  dark_mode: "moon",
  light_mode: "sun",
  contrast: "circle-half",
  monitor: "monitor",
  sort: "sort-ascending",
  swap_vert: "arrows-down-up",
  drag_indicator: "dots-six-vertical",
  drag_handle: "dots-six",
  apps: "squares-four",
  dashboard: "squares-four",
  space_dashboard: "squares-four",
  forward: "arrow-bend-up-right",
  undo: "arrow-u-up-left",
  redo: "arrow-u-up-right",
  collapse_content: "arrows-in",
  expand_content: "arrows-out",
  minimize: "minus",
  cake: "cake",
  library_books: "books",
  smart_toy: "robot",
  token: "coin",
  star_outline: "star",
  calendar_month: "calendar",
  mark_unread_chat_alt: "chat-circle-dots",
  brush: "paint-brush",
  campaign: "megaphone",
  memory: "cpu",
  rate_review: "chat-centered-text",
  workspace_premium: "medal",
  library_add: "plus-square",
  mark_chat_read: "chat-circle",
  group_add: "users-three",
  share: "share-network",
  delete_sweep: "trash",
  mark_chat_unread: "chat-circle-dots",
  pin_invoke: "push-pin",
  create_new_folder: "folder-plus",
  folder_off: "folder-minus",
  notifications_active: "bell-ringing",
  do_not_disturb_off: "minus-circle",
  notification_settings: "bell",
  drive_file_rename_outline: "pencil-simple",
  people: "users",
  policy: "shield-check",
  first_page: "caret-double-left",
  last_page: "caret-double-right",
  video_call: "video-camera",
  "settings-fill": "gear-six",
  "radio_button_checked-fill": "radio-button",
} as Record<string, IconName>;
